export enum RoutePath {
  PatientListPage = '/',
  LoginPage = '/login',
  SignUpPage = '/signup',
  NewPatientPage = '/patients/new',
  SinglePatientPage = '/patients/:patientId',
  NewBraceOrderPage = '/patients/:patientId/braces/new',
  ProfilePage = '/profile',
  PaymentPage = '/patients/:patientId/:braceId/order',
  SimulationReportPage = '/patients/:patientId/:braceId/report',
}
